let mainFunction: (() => string) | undefined;

export async function initUUID() {
    if (!mainFunction) {
        mainFunction = crypto?.randomUUID?.bind(crypto);
        if (!mainFunction) {
            const {v4} = await import("uuid");
            mainFunction = v4;
        }
    }
}

export default function uuid(): string {
    if (!mainFunction) {
        throw new Error("UUID function not initialized. Call initUUID() first.");
    }
    return mainFunction();
}
